import React, { Component } from "react";
import styled from "styled-components";
import { withPage } from "../../Page";
import { StaticFluidImage } from "../../Components/StaticImage/";
import IntroSection from "../../Components/IntroSection";
import PartSection from "../../Components/PartSection";

class FaqPage extends Component {
  render() {
    return (
      <Wrapper>
        <div className="banner">
          <StaticFluidImage
            path="banner04.jpg"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 2
            }}
          />
          <h3>- FAQ -</h3>
        </div>
        <div className="container">
          <Content>
            {`新手解惑\nＱ1.我要如何成為好咖嚴選的會員？\nA: 透過 Facebook或Google「社群帳號」進行登入，就可以立即開始購買囉！\nＱ2.成為好咖嚴選的會員需要付費嗎？\nA: 成為好咖嚴選的會員不用註冊費用，也不需要訂閱費。\nＱ3.一定要成為好咖嚴選的會員，才能購買平台上的商品嗎？\nA: 是的，為了保障您的購買權益，成為好咖會員才能享有購買的各項活動以及優惠方案。\nＱ4.是否有優惠方案提供給會員？\nA: 我們會不定期提供優惠活動以及合作來給喜愛我們的消費者回饋喔！\n\n購買流程\nＱ1.我要如何購買「好咖嚴選」平台上的商品呢？\nA: 選購你想要的商品，放入購物車內，在結帳的時候平台會自動協助金額的加總。\nＱ2.提供什麼付款方式？\nA: 目前好咖嚴選只提供先線上信用卡付款，未來會再陸續開放更多付款方式喔。\n\n配送商品\nＱ1.好咖嚴選能送到台灣以外的國家嗎？\nA: 目前只限台灣國內購買，未來我們將會陸續開發更多國外服務。\nＱ2.完成咖啡豆訂購，台灣地區多久才能收到？\nA: 好咖嚴選都是由店家直接出貨，依照國內配送的工作天大約是在下訂後5-7個工作天喔。\nＱ3.運費如何計算？\nA: 國內運費目前為內含在商品價格當中，未來將改為商品統一出貨，則會再另行公布運費的收費標準喔！\nＱ4.好咖嚴選是用什麼寄送方式呢？\nA: 目前訂單完成後，店家都會以宅配或是郵寄的方式出貨，未來會陸續有更多寄送模式。\nＱ5.我剛如何追蹤購買的商品、以及訂單處理出貨狀況？\nA: 在成為好咖嚴選的會員後，你可以在個人檔案中找到我的訂單，從訂單中了解到訂購的詳情喔！\nＱ6.收到商品有缺件，應該如何處理？\nA: 若您收到的商品在未拆封的狀態下發現瑕疵，請拍照並寫信至平台聯絡表單或service@hecafe.com.tw。經過好咖嚴選客服團隊判斷後將給予退費。\nＱ7.可否指定訂單到貨日?到貨時間?\nA: 為希望咖啡產品的新鮮度，我們都會盡早出貨給消費者，目前還沒辦指定訂單到貨日及時間，未來我們加入更多物流服務後，會再公告給消費者知道喔！\n\n售後服務、退貨說明\nＱ1.關於退（換）貨及七天鑑賞期說明\nA: 依消保法規定，基於保障消費者個人衛生，除商品瑕疵或不良外，本商品如經拆封或經使用，，即可能影響退(換)貨權利。 我們提供商品到貨七日鑑賞期（包含例假），此鑑賞期並非「試用期」，若您對於訂購之商品或服務不甚滿意且欲辦理退換貨時，商品必須是全新且包裝完整狀態（需包含完整商品、贈品及包裝盒，並置入於原外包裝箱內等），否則恕不接受退（換）貨。\nＱ2 無法受理退貨原因\nA: 下列狀況無法辦理退換貨，敬請見諒： (1) 超過七日鑑賞期  (2)宅配配送人員服務態度不佳。 (3) 約定之送貨時間，宅配遲延送達(指定時段為參考用，宅配公司會依當天的貨量以及路線來安排)。 (4)商品已拆封，在沒有任何瑕疵或損壞的情況下，恕不接受退換貨服務。 (5) 商品訂購錯誤，恕不接受退換貨服務。 (6) 個人主觀口味及飲食習慣差異因素，恕不接受退換貨服務。 (7) 贈送之商品，恕不接受退換貨服務。\nＱ3.退（換）貨流程\nA: 若商品因我方寄送疏失（寄錯品項、運送破損、瑕疵豆） 收到商品七日內，請將商品問題拍照留存，聯繫我們線上客服（非上班時間，本公司將於隔日受理）， 並註明您的單號以及退貨原因，客服人員將會協助處理。\nＱ4.訂單取消/辦理退貨，請問費用如何退還\nA: 將依照您當初訂單的付款方式做後續退款。\n
          `}
          </Content>
        </div>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  & > .banner {
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    width: 100%;
    height: 600px;
    background-color: lightgray;

    & > h3 {
      position: absolute;
      z-index: 3;
      letter-spacing: 20px;
      font-size: 54px;
      color: white;
    }

    @media screen and (max-width: 650px) {
      & > h3 {
        letter-spacing: 10px;
        font-size: 40px;
      }
    }

    @media screen and (max-width: 550px) {
      height: 300px;
      & > h3 {
        letter-spacing: 5px;
        font-size: 26px;
      }
    }
  }

  & > .container {
    margin: 0 auto;
    padding: 10px;
    max-width: 720px;
    width: 100%;
  }
`;

const Content = styled.div`
  padding: 70px 10px;
  white-space: pre-wrap;
  line-height: 40px;
  font-size: 14px;
  color: #353535;
`;

export default withPage(FaqPage);
